import { Box, Button, Stack } from "@mui/material";
import { use, useEffect, useRef, useState } from "react";
import { GLItemsDTO } from "../../../DTO/GLItemsDTO";
import LogChatCreateMsg from "./LogChatCreateMsg";
import LogChatMsg from "./LogChatMsg";
import { InfinitScroll } from "../../../services/InfinitScroll";
import { GLItemKind, GLItemStatus } from "../../../DTO/GLItemDTO";
import { Minimize, ZoomIn } from "@mui/icons-material";
import { Maximize, ZoomOut } from "react-feather";

import './LogChat.scss'

enum Status {
    loading,
    loadMore,
    idle,
}

export default function LogChat({
    id,
    personId,
    disableNewMsg,
    needle,
    kind,
    statusKind,
    onClickDetail,
}: {
    id?: number,
    personId?: number,
    disableNewMsg?: boolean,
    needle?: string,
    kind?: GLItemKind,
    statusKind?: GLItemStatus,
    onClickDetail?: (id: number) => void,
}) {
    const [status, setStatus] = useState(Status.loading)
    const [minMax, setMinMax] = useState<'minItems'|'normalItems'>('minItems')
    const [glitems] = useState(new GLItemsDTO({
        id: id && id > -1 ? id : undefined,
        page: 1,
        limit: 20,
        personId,
        needle,
        kind,
        status: statusKind,
    }))
    useEffect(() => {
        setStatus(Status.loading)
        glitems.patchRequest({
            personId,
            kind,
            status: statusKind,
        })
        glitems.getFresh().then(() => setStatus(Status.idle))
    }, [personId, kind, statusKind])

    useEffect(() => {
        setStatus(Status.loading)
        glitems.setNeedle(needle || '').then(() => setStatus(Status.idle))
    }, [needle])
    
    async function refresh() {
        setStatus(Status.loading)
        await glitems.getFresh()
        setStatus(Status.idle)
    }

    const [infinitScroll] = useState(new InfinitScroll({
        ref: useRef(null),
        cb: async () => {
            console.log('infinitscroll cb')
            if (!glitems.allowInfinitScroll) { return }
            setStatus(Status.loadMore)
            await glitems.getNextPage()
            setStatus(Status.idle)
        },
        saveScrollPositionCb: (scrollPosition: number) => {
            console.log('current scroll position')
        },
        page: 1,
    }))

        
    return <Box>       
        <Stack
          spacing={0}
          ref={infinitScroll.getRef()}
          className={`LogChat scrollContent`}
          sx={{
            maxHeight: '90vh'
          }}
        >
            <Stack
                direction={'row'}
                sx={{
                    justifyContent: 'space-between',
                }}
            >
                <Box></Box>
                {
                    minMax === 'minItems' ? <Button
                        onClick={() => setMinMax('normalItems')}
                    >
                        <ZoomIn /> Mehr anzeigen
                    </Button> : <Button
                        onClick={() => setMinMax('minItems')}
                    >
                        <ZoomOut /> Weniger anzeigen
                    </Button>
                }
            </Stack>
            {
                !disableNewMsg &&
                <LogChatCreateMsg
                    saveCB={refresh}
                    personId={personId}
                    id={id}
                />
            }
            {status === Status.loading && <Box>Lade...</Box>}
            {status !== Status.loading && glitems.items.length === 0 && <Box>Keine Einträge</Box>}
            
            <Stack
                spacing={4}
                className={minMax}
            >
                {status !== Status.loading && glitems.get().map(item =>
                <LogChatMsg
                    key={item.id}
                    saveCB={refresh}
                    item={item}
                    onClickDetail={onClickDetail}
                />)}    
            </Stack>
        </Stack>
    </Box>
}
